"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
const _ = __importStar(require("lodash"));
const vue_property_decorator_1 = require("vue-property-decorator");
const vue_class_component_1 = require("vue-class-component");
const core_1 = require("@integro/core");
let WasteBinReadingModal = class WasteBinReadingModal extends (0, vue_class_component_1.mixins)(core_1.UserComponentMixin) {
    componentMetadata = {
        kind: "modal",
    };
    beforeCreate() {
    }
    objectId;
    onObject_id(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("objectId");
    }
    size;
    onSize(newValue, oldValue) {
        if (_.isEqual(newValue, oldValue))
            return;
        this.loadDataThrottled("size");
    }
    formId;
    async $$load_formId() {
        return this.$fn.randomElementId();
    }
    item;
    async $$load_item() {
        return this.$fn.fetch('waste_bins/get_reading', { parameters: { id: this.objectId } }).then(d => new this.$fn.Resource(d));
    }
    ux;
    b_5534025912102772_auto;
    b_5430362791568289_variantMap;
    dataMembers = ['formId', 'item', 'ux', 'b_5534025912102772_auto', 'b_5430362791568289_variantMap'];
    data() {
        return {
            ...this.mixinData(),
            actions: this.getActions(),
            ...{
                formId: null,
                item: null,
                ux: null,
                b_5534025912102772_auto: false,
                b_5430362791568289_variantMap: {
                    empty: "success",
                    full: "warning",
                },
            },
        };
    }
    get document() {
        if (this.loaded) {
            return {
                title: this.$fn.gettext("Waste bin reading"),
            };
        }
        return null;
    }
    async act_7315092382398562_closeModal_1964_getActionArgs($event) {
        return {
            name: this.modalName,
            result: {
                close: true,
                cancel: true,
            },
        };
    }
    async evh_7315092382398562_close(event, scope) {
        return await this.actions.evh_7315092382398562_close.executeFromDOM(this, event, scope);
    }
    async evh_2248226175642056_close(event, scope) {
        return await this.actions.evh_2248226175642056_close.executeFromDOM(this, event, scope);
    }
    async act_2286348834130966_setData_1970_getActionArgs($event) {
        return {
            path: "item",
            value: $event && $event.data.response.data,
            resolve: false,
            noTouchLastLoaded: false,
            noTakeSnapshot: false,
        };
    }
    async act_2286348834130966_request_1968_getActionArgs($event) {
        return {
            operation: "waste_bins/update_reading",
            data: {
                id: this.item.id,
                state: this.item.state == 'full' ? 'empty' : 'full'
            },
        };
    }
    async evh_2286348834130966_clickPreventStop(event, scope) {
        return await this.actions.evh_2286348834130966_clickPreventStop.executeFromDOM(this, event, scope);
    }
    async evh_1548630417156826_clickPreventStop(event, scope) {
        return await this.actions.evh_1548630417156826_clickPreventStop.executeFromDOM(this, event, scope);
    }
    actions;
    getActions() {
        const act_7315092382398562_closeModal_1964 = new core_1.actions.CloseModalAction({
            actionArgs: this.act_7315092382398562_closeModal_1964_getActionArgs,
            events: [],
        });
        const evh_7315092382398562_close_1963 = new core_1.actions.EventHandlerImpl({
            action: act_7315092382398562_closeModal_1964,
            event: "close",
            displayName: "closeModal",
        });
        const evh_7315092382398562_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_7315092382398562_close_1963],
        });
        const act_2248226175642056_closeComponent_1966 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_2248226175642056_close_1965 = new core_1.actions.EventHandlerImpl({
            action: act_2248226175642056_closeComponent_1966,
            event: "close",
            displayName: "closeComponent",
        });
        const evh_2248226175642056_close = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2248226175642056_close_1965],
        });
        const act_2286348834130966_setData_1970 = new core_1.actions.SetDataAction({
            actionArgs: this.act_2286348834130966_setData_1970_getActionArgs,
            events: [],
        });
        const evh_2286348834130966_success_1969 = new core_1.actions.EventHandlerImpl({
            action: act_2286348834130966_setData_1970,
            event: "success",
            displayName: "setData",
        });
        const act_2286348834130966_request_1968 = new core_1.actions.RequestAction({
            actionArgs: this.act_2286348834130966_request_1968_getActionArgs,
            displayName: "toggleState",
            events: [evh_2286348834130966_success_1969],
        });
        const evh_2286348834130966_clickPreventStop_1967 = new core_1.actions.EventHandlerImpl({
            action: act_2286348834130966_request_1968,
            event: "click.prevent.stop",
            displayName: "toggleState",
        });
        const evh_2286348834130966_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_2286348834130966_clickPreventStop_1967],
        });
        const act_1548630417156826_closeComponent_1972 = new core_1.actions.CloseComponentAction({
            events: [],
        });
        const evh_1548630417156826_clickPreventStop_1971 = new core_1.actions.EventHandlerImpl({
            action: act_1548630417156826_closeComponent_1972,
            event: "click.prevent.stop",
            displayName: "closeComponent",
        });
        const evh_1548630417156826_clickPreventStop = new core_1.actions.EventHandlerGroup({
            handlers: [evh_1548630417156826_clickPreventStop_1971],
        });
        return {
            act_7315092382398562_closeModal_1964,
            evh_7315092382398562_close_1963,
            evh_7315092382398562_close,
            act_2248226175642056_closeComponent_1966,
            evh_2248226175642056_close_1965,
            evh_2248226175642056_close,
            act_2286348834130966_setData_1970,
            evh_2286348834130966_success_1969,
            act_2286348834130966_request_1968,
            evh_2286348834130966_clickPreventStop_1967,
            evh_2286348834130966_clickPreventStop,
            act_1548630417156826_closeComponent_1972,
            evh_1548630417156826_clickPreventStop_1971,
            evh_1548630417156826_clickPreventStop,
            toggleState: act_2286348834130966_request_1968,
        };
    }
};
__decorate([
    (0, vue_property_decorator_1.Prop)({
        required: true,
    }),
    __metadata("design:type", typeof (_a = typeof int !== "undefined" && int) === "function" ? _a : Object)
], WasteBinReadingModal.prototype, "objectId", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('objectId'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WasteBinReadingModal.prototype, "onObject_id", null);
__decorate([
    (0, vue_property_decorator_1.Prop)({
        type: String,
        default: "md",
    }),
    __metadata("design:type", String)
], WasteBinReadingModal.prototype, "size", void 0);
__decorate([
    (0, vue_property_decorator_1.Watch)('size'),
    __metadata("design:type", Function),
    __metadata("design:paramtypes", [Object, Object]),
    __metadata("design:returntype", void 0)
], WasteBinReadingModal.prototype, "onSize", null);
WasteBinReadingModal = __decorate([
    (0, vue_property_decorator_1.Component)()
], WasteBinReadingModal);
exports.default = WasteBinReadingModal;
vue_property_decorator_1.Vue.component("WasteBinReadingModal", WasteBinReadingModal);
